// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/system.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/assets/images/blueprint.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/assets/images/members.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_zgQjG {
  overflow-y : auto;
}

.blueprintCard_JU1yV {
  position : relative;
  display: inline-block;
  max-width: 300px;
}

.bigButton__l90A {
  margin : 40px;
  width : 250px;
  height: 250px;
  background-size:contain;
  background-repeat: no-repeat;

  display: inline-flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color : white;
  font-size: 24px;
  font-weight: bolder;
  border:none;
  outline: none;
  transition: width 0.3s ease-in-out, height 0.3s ease-in-out, margin 0.3s ease-in-out;
}

.bigButton__l90A.small_qOclD {
  margin-top: 10px;
  width : 60px;
  height:60px;
}

.bigButton__l90A.small_qOclD div { 
  font-size:13px;
}

.bigButton__l90A:hover {
  box-shadow: 0 2px 10px rgba( 0,0,0,0.25);
}
.bigButton__l90A div {
  text-shadow: 0 0 1px black;
  transition: font-size 0.3s ease-in-out
}

.systemButton_GwPMh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.blueprintButton_B8BYW {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.memberButton_XdqaT {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.labelGroup_xZ5js {
  margin-left : 10px;
  margin-right : 10px;
}

.sectionBreak_wn_iJ {
  background-color : var( --color-base200 );
  height: 1px;
  width: 100%;
  margin-top: var( --size-padMedium, 8px );
  margin-bottom: var( --size-padMedium, 8px );
}

.icon_zU9Zm {
  color : #67798E;
  padding-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/project/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,4BAA4B;;EAE5B,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,oFAAoF;AACtF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,yDAAmD;AACrD;;AAEA;EACE,yDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".header {\n  overflow-y : auto;\n}\n\n.blueprintCard {\n  position : relative;\n  display: inline-block;\n  max-width: 300px;\n}\n\n.bigButton {\n  margin : 40px;\n  width : 250px;\n  height: 250px;\n  background-size:contain;\n  background-repeat: no-repeat;\n\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  color : white;\n  font-size: 24px;\n  font-weight: bolder;\n  border:none;\n  outline: none;\n  transition: width 0.3s ease-in-out, height 0.3s ease-in-out, margin 0.3s ease-in-out;\n}\n\n.bigButton.small {\n  margin-top: 10px;\n  width : 60px;\n  height:60px;\n}\n\n.bigButton.small div { \n  font-size:13px;\n}\n\n.bigButton:hover {\n  box-shadow: 0 2px 10px rgba( 0,0,0,0.25);\n}\n.bigButton div {\n  text-shadow: 0 0 1px black;\n  transition: font-size 0.3s ease-in-out\n}\n\n.systemButton {\n  background-image: url(/assets/images/system.png);\n}\n\n.blueprintButton {\n  background-image: url(/assets/images/blueprint.png);\n}\n\n.memberButton {\n  background-image: url(/assets/images/members.png);\n}\n\n.labelGroup {\n  margin-left : 10px;\n  margin-right : 10px;\n}\n\n.sectionBreak {\n  background-color : var( --color-base200 );\n  height: 1px;\n  width: 100%;\n  margin-top: var( --size-padMedium, 8px );\n  margin-bottom: var( --size-padMedium, 8px );\n}\n\n.icon {\n  color : #67798E;\n  padding-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_zgQjG`,
	"blueprintCard": `blueprintCard_JU1yV`,
	"bigButton": `bigButton__l90A`,
	"small": `small_qOclD`,
	"systemButton": `systemButton_GwPMh`,
	"blueprintButton": `blueprintButton_B8BYW`,
	"memberButton": `memberButton_XdqaT`,
	"labelGroup": `labelGroup_xZ5js`,
	"sectionBreak": `sectionBreak_wn_iJ`,
	"icon": `icon_zU9Zm`
};
export default ___CSS_LOADER_EXPORT___;
